import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

export interface ChartLegendEntry {
  id: string;
  label: string;
  color: string;
}

export function ChartLegend({ entries }: { entries: ChartLegendEntry[] }): ReactNode {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mt: 2 }}>
      {entries.map((entry) => (
        <Box key={entry.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: entry.color }} />
          <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.secondary' }}>
            {entry.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
